module.exports = __webpack_public_path__ + "img/tgd1x_inspect_back.37e7f837.png";